module.exports = __webpack_public_path__ + "static/media/recipe_category_2.55098402.png";